import Localization from 'lib/localization';

export default {
    lxBlockTitle() {
        return Localization.get('badoo_safety_center@navigation.helplines.title');
    },
    lxNavigationForwardA11yLabel() {
        return Localization.get('badoo_safety_center@navigation.helplines.forward.a11y.label');
    },
    lxNavigationBackwardA11yLabel() {
        return Localization.get('badoo_safety_center@navigation.helplines.backward.a11y.label');
    },
};
